module.exports = "/img/CloseReel.7c3b0b.png";